import { Navigate } from "react-router-dom";
import { useAuth } from "../contexts/auth";
import { getPostLoginPath } from "../utils/postLoginPath";
import { CreateAccountForm } from "../components";
import { CreateClientForm } from "../components";
import { CreateSalonForm } from "../components";
import { ConfigureSalonForm } from "../components";
import { CreateCategoryForm } from "../components";
import { CreateServiceForm } from "../components";
import { EditServiceForm } from "../components";
import { EditClientForm } from "../components";
import {
  HomePage,
  TasksPage,
  ProfilePage,
  ManageUsersPage,
  ReportingPage,
  PivotgridClassPage,
  InventoryPage,
  ReportsSQLPage,
  ManufacturersSQLPage,
  RolledReportsSQLPage,
  SalonReportsSQLPage,
  StylistSpendSQLPage,
  SalesReportPage,
  Scheduler,
  Receiving,
  Order,
  SearchServices,
  StylistServices,
  EditAClientPage,
  SearchStylists,
  AddServiceToStylist,
  ManageProducts,
  ReWeightReportPage,
  ReOrderReportPage,
  InventoryReceivingReportPage,
  MicaInventoryReceivingReportPage,
  ClientsRetentionReportPage,
  FormulaTrackerPage,
} from "../pages";
import CheckoutSummaryReport from "../pages/reports/checkout-summary/CheckoutSummaryReport";
import BookingSourcesReport from "../pages/reports/booking-sources-report/booking-sources-report";
import SalonDashboard from "../pages/dashboard/salon";
import StylistDashboard from "../pages/dashboard/stylist";
import StylistDetailDashboard from "../pages/dashboard/stylistdetail";
import ManageCategories from "../pages/categories/manage-categories";
import ManageDistributors from "../pages/Distributors/manage-distributors";
import DistributorForm from "../pages/Distributors/distributor-form";
import ManageCancellationReasons from "../pages/CancellationReasons/manage-cancellation-reasons";
import CancellationReasonForm from "../pages/CancellationReasons/cancellation-reason-form";
import {
  ROLE_FRONT_DESK,
  ROLE_JDTECH_ADMIN,
  ROLE_SALON_ADMIN,
  ROLE_STYLIST,
  ROLE_SYSTEM_ADMIN,
} from "../utils/constants";

function RoutingDashboard() {
  const { user } = useAuth();
  return <Navigate to={getPostLoginPath(user?.userRoles, routes)} replace />;
}

const routes = [
  {
    path: "/",
    component: <RoutingDashboard />,
    allowedUserTypes: [1, 2, 3, 4, 6],
  },
  {
    path: "/pulse",
    component: <SalonDashboard />,
    allowedUserTypes: [3, 2, 4],
  },
  {
    path: "/lens",
    component: <StylistDashboard />,
    allowedUserTypes: [3, 2, 1, 6],
  },
  {
    path: "/home",
    component: <HomePage />,
    allowedUserTypes: [6],
  },
  {
    path: "/manage-users",
    component: <ManageUsersPage />,
    allowedUserTypes: [3, 2],
  },
  {
    path: "/scheduler",
    component: <Scheduler />,
    allowedUserTypes: [4, 3, 2, 1],
  },
  {
    path: "/till",
    component: <Scheduler />,
    allowedUserTypes: [4, 3, 2, 1],
  },
  {
    path: "/pulse-dashboard",
    component: <Navigate to="/pulse" replace />,
    allowedUserTypes: [3, 2, 4],
  },
  {
    path: "/lens-dashboard",
    component: <Navigate to="/lens" replace />,
    allowedUserTypes: [3, 2, 1, 6],
  },
  {
    path: "/reporting",
    component: <ReportingPage />,
    allowedUserTypes: [3],
  },
  {
    path: "/reports-sql",
    component: <ReportsSQLPage />,
    allowedUserTypes: [3],
  },

  {
    path: "/manufacturers-sql",
    component: <ManufacturersSQLPage />,
    allowedUserTypes: [3],
  },

  {
    path: "/pivotgrid-class",
    component: <PivotgridClassPage />,
    allowedUserTypes: [3],
  },
  {
    path: "/re-weight-report",
    component: <ReWeightReportPage />,
    allowedUserTypes: [
      ROLE_SALON_ADMIN,
      ROLE_SYSTEM_ADMIN,
      ROLE_JDTECH_ADMIN,
    ],
  },

  {
    path: "/re-order-report",
    component: <ReOrderReportPage />,
    allowedUserTypes: [
      ROLE_FRONT_DESK,
      ROLE_SALON_ADMIN,
      ROLE_SYSTEM_ADMIN,
      ROLE_JDTECH_ADMIN,
    ],
  },

  {
    path: "/inventory-receiving-report",
    component: <InventoryReceivingReportPage />,
    allowedUserTypes: [
      ROLE_FRONT_DESK,
      ROLE_SALON_ADMIN,
      ROLE_SYSTEM_ADMIN,
      ROLE_JDTECH_ADMIN,
    ],
  },

  {
    path: "/mica-inventory-receiving-report",
    component: <MicaInventoryReceivingReportPage />,
    allowedUserTypes: [
      ROLE_FRONT_DESK,
      ROLE_SALON_ADMIN,
      ROLE_SYSTEM_ADMIN,
      ROLE_JDTECH_ADMIN,
    ],
  },

  {
    path: "/clients-retention-report",
    component: <ClientsRetentionReportPage />,
    allowedUserTypes: [ROLE_JDTECH_ADMIN, ROLE_SALON_ADMIN],
  },

  {
    path: "/formula-tracker",
    component: <FormulaTrackerPage />,
    allowedUserTypes: [
      ROLE_SALON_ADMIN,
      ROLE_SYSTEM_ADMIN,
      ROLE_JDTECH_ADMIN,
    ],
  },

  {
    path: "/checkout-summary",
    component: <CheckoutSummaryReport />,
    allowedUserTypes: [
      ROLE_SYSTEM_ADMIN,
      ROLE_SALON_ADMIN,
      ROLE_FRONT_DESK,
      ROLE_JDTECH_ADMIN,
    ],
  },

  {
    path: "/booking-sources-report",
    component: <BookingSourcesReport />,
    allowedUserTypes: [
      ROLE_SYSTEM_ADMIN,
      ROLE_SALON_ADMIN,
      ROLE_FRONT_DESK,
      ROLE_JDTECH_ADMIN,
    ],
  },

  {
    path: "/create-account",
    component: <CreateAccountForm />,
    allowedUserTypes: [3, 2],
  },
  {
    path: "/create-account?role=stylist",
    component: <CreateAccountForm />,
    allowedUserTypes: [3, 2],
  },
  {
    path: "/users/:id",
    component: <CreateAccountForm />,
    allowedUserTypes: [3, 2],
  },
  {
    path: "/configure-salon",
    component: <ConfigureSalonForm />,
    allowedUserTypes: [3, 2],
  },
  {
    path: "/create-salon",
    component: <CreateSalonForm />,
    allowedUserTypes: [6],
  },
  {
    path: "/manage-categories",
    component: <ManageCategories />,
    allowedUserTypes: [3, 2],
  },
  {
    path: "/create-category",
    component: <CreateCategoryForm />,
    allowedUserTypes: [3, 2],
  },
  {
    path: "/manage-distributors",
    component: <ManageDistributors />,
    allowedUserTypes: [ROLE_SYSTEM_ADMIN, ROLE_JDTECH_ADMIN, ROLE_SALON_ADMIN],
  },
  {
    path: "/distributor-form",
    component: <DistributorForm />,
    allowedUserTypes: [ROLE_SYSTEM_ADMIN, ROLE_JDTECH_ADMIN, ROLE_SALON_ADMIN],
  },
  {
    path: "/manage-cancellation-reasons",
    component: <ManageCancellationReasons />,
    allowedUserTypes: [ROLE_SYSTEM_ADMIN, ROLE_JDTECH_ADMIN, ROLE_SALON_ADMIN],
  },
  {
    path: "/cancellation-reason-form",
    component: <CancellationReasonForm />,
    allowedUserTypes: [ROLE_SYSTEM_ADMIN, ROLE_JDTECH_ADMIN, ROLE_SALON_ADMIN],
  },
  {
    path: "/create-service",
    component: <CreateServiceForm />,
    allowedUserTypes: [3, 2],
  },
  {
    path: "/edit-service",
    component: <EditServiceForm />,
    allowedUserTypes: [3, 2],
  },
  {
    path: "/edit-client-form",
    component: <EditClientForm />,
    allowedUserTypes: [ROLE_SYSTEM_ADMIN, ROLE_FRONT_DESK],
  },
  {
    path: "/create-client",
    component: <CreateClientForm />,
    allowedUserTypes: [ROLE_SYSTEM_ADMIN, ROLE_FRONT_DESK],
  },
  {
    path: "/search-services",
    component: <SearchServices />,
    allowedUserTypes: [3],
  },
  {
    path: "/add-service-to-stylist",
    component: <AddServiceToStylist />,
    allowedUserTypes: [3, 2, 1],
  },
  {
    path: "/search-stylists",
    component: <SearchStylists />,
    allowedUserTypes: [3],
  },
  {
    path: "/manage-products",
    component: <ManageProducts />,
    allowedUserTypes: [3],
  },
  {
    path: "/search-stylists/stylist-services",
    component: <StylistServices />,
    allowedUserTypes: [3, 2, 1],
  },
  {
    path: "/edit-client",
    component: <EditAClientPage />,
    allowedUserTypes: [ROLE_SYSTEM_ADMIN, ROLE_FRONT_DESK],
  },
  {
    path: "/rolled-reports-sql",
    component: <RolledReportsSQLPage />,
    allowedUserTypes: [
      ROLE_STYLIST,
      ROLE_SALON_ADMIN,
      ROLE_SYSTEM_ADMIN,
      ROLE_JDTECH_ADMIN,
    ],
  },
  {
    path: "/salon-reports-sql",
    component: <SalonReportsSQLPage />,
    allowedUserTypes: [3, 2],
  },
  {
    path: "/stylist-spend-sql",
    component: <StylistSpendSQLPage />,
    allowedUserTypes: [
      ROLE_SALON_ADMIN,
      ROLE_SYSTEM_ADMIN,
      ROLE_JDTECH_ADMIN,
    ],
  },
  {
    path: "/sales-report",
    component: <SalesReportPage />,
    allowedUserTypes: [3, 2, 4, 6], // SYSTEM_ADMIN, SALON_ADMIN, FRONT_DESK, JDTECH_ADMIN
  },
  {
    path: "/inventory",
    component: <InventoryPage />,
    allowedUserTypes: [3, 2],
  },

  {
    path: "/stylist-dashboard-detail",
    component: <StylistDetailDashboard />,
    allowedUserTypes: [3, 2, 1, 6],
  },
  {
    path: "/inventory-receiving",
    component: <Receiving />,
    allowedUserTypes: [3, 2, 4],
  },
  {
    path: "/reorder",
    component: <Order />,
    allowedUserTypes: [3, 2, 4],
  },
  {
    path: "/tasks",
    component: <TasksPage />,
    allowedUserTypes: [3],
  },
  {
    path: "/profile",
    component: <ProfilePage />,
    allowedUserTypes: [3],
  },
];

export default routes.map((route) => {
  return {
    ...route,
    component: route.component,
  };
});
